import React from 'react';
import Button from './Button';

const ConfirmDialog = ({ 
    isOpen, 
    title = 'Confirm Action', 
    message = 'Are you sure you want to proceed?', 
    confirmText = 'Confirm', 
    cancelText = 'Cancel',
    onConfirm, 
    onCancel,
    confirmVariant = 'primary',
    cancelVariant = 'secondary',
    loading = false
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-60">
            <div className="bg-white rounded-lg max-w-md w-full mx-4">
                <div className="p-6">
                    <div className="mb-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                            {title}
                        </h3>
                        <p className="text-gray-600">
                            {message}
                        </p>
                    </div>
                    <div className="flex justify-end space-x-3">
                        <Button
                            type="button"
                            variant={cancelVariant}
                            onClick={onCancel}
                            loading={loading}
                        >
                            {cancelText}
                        </Button>
                        <Button
                            type="button"
                            variant={confirmVariant}
                            onClick={onConfirm}
                            loading={loading}
                        >
                            {confirmText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog; 